class BundleStickyCTA extends HTMLElement {

	constructor() {
		super();
		this.classList.add('init');

		const pageButtons = document.querySelectorAll('bundle-start-button:not(bundle-sticky-cta *)');
		
		const observer = new IntersectionObserver(entries => {
			if (entries.every(e => !e.isIntersecting)) this.classList.add('active');
			else this.classList.remove('active');
		}, { rootMargin: '-100px 0px 0px 0px' });

		pageButtons.forEach(btn => observer.observe(btn));
	}
}

customElements.define('bundle-sticky-cta', BundleStickyCTA);
 